import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appLowercaseOnChange]'
})
export class LowercaseOnChangeDirective implements OnInit {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit(): void {
    // Converte o valor inicial
    this.toLowercase();
  }

  @HostListener('change')
  onChange(): void {
    this.toLowercase();
  }

  private toLowercase(): void {
    const input = this.el.nativeElement;
    const lower = input.value.toLowerCase();
    input.value = lower;
    input.dispatchEvent(new Event('input'));
  }
}
